import { EMAIL_STATISTICS_API } from 'modules/email-statistics/api/email-statistics-api'
import {
  EmailStatisticsChartsInterface,
  EmailStatisticsFilterInterface,
} from 'modules/email-statistics/types/email-statistics-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useEmailStatisticsCharts = (filter: EmailStatisticsFilterInterface) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, EmailStatisticsChartsInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.dateSince !== null ? `filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ''
  }`

  return useSWR(() => {
    if (!user || filter.dateSince === null) return
    return `${EMAIL_STATISTICS_API}/chart?${filterApi}`
  }, fetcher)
}
